// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".semantic-ui .tour-layout-edit-container .ui.icon.button.tour-save-btn .icon {\n  vertical-align: baseline;\n}\n", ""]);
// Exports
module.exports = exports;
